import { ArrowUpRight } from "lucide-react";
import { ApiError } from "@shared/client/api";
import { useT } from "@shared/client/locale";
import { Link } from "@shared/client/navigation";

/** Lien vers les plans, sous un refus lié au plan (réponse 402 de l'API). */
export function UpgradeLink({ label }: { label?: string }) {
  const t = useT();
  return (
    <Link
      className="inline-flex items-center gap-1 font-semibold text-primary underline-offset-2 hover:underline"
      href="/app/settings#abonnement"
    >
      {label ?? t.settings.billing.seePlans} <ArrowUpRight size={13} aria-hidden="true" />
    </Link>
  );
}

export const isPlanLimit = (cause: unknown) => cause instanceof ApiError && cause.status === 402;
